"use strict";

var _defineProperty2 = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _toConsumableArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _clsx = _interopRequireDefault(require("clsx"));
var _AccordionSummaryView = _interopRequireDefault(require("../summary/AccordionSummaryView"));
var _Types = require("../inputs/Types");
var _FacetStyle = _interopRequireDefault(require("./FacetStyle"));
var _FilterItems = _interopRequireDefault(require("../inputs/FilterItems"));
var _Sort = require("../../utils/Sort");
var _clearIcon = _interopRequireDefault(require("./assets/clearIcon.svg"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var FacetView = function FacetView(_ref) {
  var classes = _ref.classes,
    facet = _ref.facet,
    onClearFacetSection = _ref.onClearFacetSection,
    onClearSliderSection = _ref.onClearSliderSection,
    CustomView = _ref.CustomView,
    autoComplete = _ref.autoComplete,
    upload = _ref.upload;
  var _ref2 = (0, _react.useState)(false),
    _ref3 = _slicedToArray(_ref2, 2),
    expand = _ref3[0],
    setExpand = _ref3[1];
  var onExpandFacet = function onExpandFacet() {
    return setExpand(!expand);
  };

  /**
  * expand section incase of active local search
  */
  (0, _react.useEffect)(function () {
    if (autoComplete && autoComplete.length > 0 || upload && upload.length > 0) {
      setExpand(true);
    }
  }, [autoComplete, upload]);
  var _ref4 = (0, _react.useState)(null),
    _ref5 = _slicedToArray(_ref4, 2),
    sortBy = _ref5[0],
    setSortBy = _ref5[1];
  var onSortFacet = function onSortFacet(type) {
    setSortBy(type);
  };
  var onClearSection = function onClearSection() {
    setSortBy(null);
    if (facet.type === _Types.InputTypes.SLIDER) {
      onClearSliderSection(facet);
    } else {
      onClearFacetSection(facet);
    }
  };
  /**
   * display checked items on facet collapse
   */
  var type = facet.type,
    facetValues = facet.facetValues;
  var selectedItems = facetValues && facetValues.filter(function (item) {
    return item.isChecked;
  });
  var displayFacet = _objectSpread({}, facet);
  displayFacet.facetValues = selectedItems;
  var isActiveFacet = _toConsumableArray(selectedItems).length > 0;
  var limitCheckBoxCount = (facet === null || facet === void 0 ? void 0 : facet.showCheckboxCount) || 5;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Accordion, {
    square: true,
    expanded: expand,
    onChange: onExpandFacet,
    classes: {
      root: classes.expansionPanelsideBarItem
    },
    id: facet.section
  }, CustomView ? /*#__PURE__*/_react.default.createElement(CustomView, {
    facet: facet,
    facetClasses: isActiveFacet ? "activeFacet".concat(facet.section) : "inactiveFacet".concat(facet.section)
  }) : /*#__PURE__*/_react.default.createElement(_AccordionSummaryView.default, null, /*#__PURE__*/_react.default.createElement("div", {
    id: "filterGroup_ ".concat(facet.datafield, "\n                ").concat(facet.label),
    className: (0, _clsx.default)(classes.subSectionSummaryText, _defineProperty2({}, "activeFacet".concat(facet.section), isActiveFacet))
  }, facet.label)), (facet.type === _Types.InputTypes.SLIDER || facetValues.length === 0) && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.NonSortGroup
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.NonSortGroupItem
  }, "No data for this field")), (facet.type === _Types.InputTypes.SLIDER || facetValues.length > 0) && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.sortGroup
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.sortGroupIcon
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    style: {
      fontSize: 10
    },
    onClick: onClearSection
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _clearIcon.default,
    height: 12,
    width: 12,
    alt: "clear-icon"
  }))), facet.type === _Types.InputTypes.CHECKBOX && facetValues.length > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _clsx.default)(classes.sortGroupItem, _defineProperty2({}, classes.highlight, sortBy === _Sort.sortType.ALPHABET)),
    onClick: function onClick() {
      onSortFacet(_Sort.sortType.ALPHABET);
    }
  }, "Sort alphabetically"), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _clsx.default)(classes.sortGroupItemCounts, _defineProperty2({}, classes.highlight, sortBy === _Sort.sortType.NUMERIC)),
    onClick: function onClick() {
      onSortFacet(_Sort.sortType.NUMERIC);
    }
  }, "Sort by count"))), /*#__PURE__*/_react.default.createElement(_FilterItems.default, {
    facet: facet,
    sortBy: sortBy
  })), !expand && type === _Types.InputTypes.CHECKBOX && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.List, {
    id: "filter_Items"
  }, /*#__PURE__*/_react.default.createElement(_FilterItems.default, {
    facet: displayFacet
  }))), !expand && selectedItems.length > limitCheckBoxCount && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.showMore,
    onClick: onExpandFacet
  }, "...expand to see all selections"));
};
var _default = (0, _core.withStyles)(_FacetStyle.default)(FacetView);
exports.default = _default;